// ブランド表記の置き場。画面・PDF・フッターが同じ名前を名乗るよう、ここだけを直す。
// 本サービスは「建築知能」のサービス。成果物名は「立地レポート」(パートナー版は reportTitle で差し替える)。

/** 親ブランド。 */
export const BRAND_NAME = '建築知能';
/** サービス名 (ヘッダーのロックアップ「建築知能｜とちの立地チェック」の右側)。 */
export const SERVICE_NAME = 'とちの立地チェック';
/** 文中で名乗るときの形。 */
export const SERVICE_FULL_NAME = `${BRAND_NAME} ${SERVICE_NAME}`;
/** 成果物名。 */
export const REPORT_NAME = '立地レポート';
/** 運営。 */
export const OPERATOR_NAME = '株式会社アーキロイド';

/** C 向けサービスの公開 URL (パートナー版のサイトから一般向けへ案内するときに使う)。
 *  サブディレクトリ名は infra の base_path と同じ値。 */
export const SERVICE_URL = 'https://kenchiku-chino.com/tochi-check/';

/** 貴社ブランド版 (パートナー版) の実例として案内するサイト。 */
export const PARTNER_SAMPLE = { name: '「構造塾」版', url: 'https://location.kouzoujuku.com/' } as const;

/** 建築知能のサイトと姉妹サービス。 */
export const BRAND_URL = 'https://kenchiku-chino.com/';
export const CONTACT_URL = 'https://kenchiku-chino.com/contact/';
export const TERMS_URL = 'https://kenchiku-chino.com/terms-of-service/';
export const PRIVACY_URL = 'https://kenchiku-chino.com/privacy-policy/';
export const OPERATOR_URL = 'https://archiroid.co.jp/';
export const FAMILY_LINKS = [
  { label: '建築知能トップ', href: 'https://kenchiku-chino.com/' },
  { label: 'トピックス', href: 'https://kenchiku-chino.com/articles/' },
  { label: 'まどりの構造チェック', href: 'https://kenchiku-chino.com/madori-check/' },
  { label: '温熱計算（工務店・設計者向け）', href: 'https://kenchiku-chino.com/cad/thermal/' },
  { label: 'お問い合わせ', href: CONTACT_URL },
] as const;
